import { Colors } from '@sigma-frontend-libs/commons'

import info from '@/components/info'

export default function(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate('misc.hints.componentNotFound'),
        color: Colors.error
      }
    }
  )
}
